import ArticleLayout from './ArticleLayout';

export default ArticleLayout;
